export default "__VITE_ASSET__CvVOuhWp__"